<template>
  <div class="object-link-wrapper">
      <a @click.prevent="openDetail"
        class="no-background-image">
        <span class="inner-link" v-html="elementHTML"></span>
      </a>
    <ObjectDetailLight ref="detail" v-show="object" :object="object"/>
  </div>
</template>

<script>
import ObjectDetailLight from "./ObjectDetailLight";
import {getVueInstance} from "@/helpers/AppHelpers";
import Vue from 'vue';
export default {
  name: 'ObjectLink',
  props: ['domElement'],
  components:{
    ObjectDetailLight
  },
  data(){
    return {
      object: ''
    }
  },
  computed: {
    elementHTML(){
      return this.domElement.innerHTML;
    }
  },
  methods:{
    async openDetail(){
      // If the object is already in memory, don't call the endpoint
      if(this.object === ''){
        const objectResponse = await fetch(
          process.env.VUE_APP_HOST + '/.rest/gallery/v1/object/slug?slug=' + this.getObjectSlug()
        );

        const object = await objectResponse.json();

        this.object = object.object;
      }

      let existingObjectDetail = document.querySelector('.object-detail-modal:not([id*="undefined"])');
      const isOverlayOpen = Vue.prototype.$lastOverlay && Vue.prototype.$lastOverlay.length > 0;
      if (existingObjectDetail && !isOverlayOpen) {
        let id = existingObjectDetail.getAttribute('id');
        let objectDetailInst = getVueInstance(id);
        
        if (objectDetailInst && objectDetailInst.parentId) {
          let elementDetailComponent = getVueInstance(objectDetailInst.parentId);
          if (elementDetailComponent) {
            // Close any open overlays (like TermDetail or ObjectDetailLight) before opening the new object
            document.querySelectorAll('.terms-detail').forEach(el => {
              if (el.__vue__ && el.__vue__.isOpen) {
                const termVue = el.__vue__;
                termVue.close();
                if (Vue.prototype.$lastOverlay) {
                  Vue.prototype.$lastOverlay = Vue.prototype.$lastOverlay.filter(id => id !== termVue.term['@id']);
                }
              }
            });

            document.querySelectorAll('.object-detail-modal').forEach(el => {
              if (el.__vue__ && el.__vue__.isOpen && typeof el.__vue__.close === 'function') {
                const lightVue = el.__vue__;
                lightVue.close();
                if (Vue.prototype.$lastOverlay) {
                  Vue.prototype.$lastOverlay = Vue.prototype.$lastOverlay.filter(id => id !== lightVue.object['@id']);
                }
              }
            });

            elementDetailComponent.currentObject = {
              ...elementDetailComponent.currentObject,
              updateHistory: true,
              category: this.object.category,
              ...this.object
            };

            if (typeof elementDetailComponent.openObjectDetailComponent === 'function') {
              elementDetailComponent.openObjectDetailComponent();
            }

            setTimeout(() => {
              window.scrollTo({ top: 0, left: 0, behavior: "smooth"});
            }, 0);
            return;
          }
        }
      }

      this.$nextTick(() => {
        this.$refs.detail.open();
      });
    },
    getObjectSlug(){
      // Get only the last slug from the path, so that even child objects can work correctly
      const splitPath = decodeURI(this.domElement.href).split('/');
      return splitPath[splitPath.length - 1].replaceAll('}', '');
    }
  }
};
</script>

<style scoped lang="scss">
  @import 'src/vars.scss';
  .object-link-wrapper{
    display:inline;
  }
</style>